module.exports = __webpack_public_path__ + "glyphicons-halflings-regular.f4769f9bdb7466be6508.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/fonts/glyphicons-halflings-regular.eot
// module id = ../../../../../src/fonts/glyphicons-halflings-regular.eot
// module chunks = 2